import { joyspacePermissionType } from '../../types';
export const pageMenus = [
  {
    value: joyspacePermissionType.ReadOnly,
    label: '仅阅读',
    tip: '可查看文档',
  },
  {
    value: joyspacePermissionType.ReadWrite,
    label: '可编辑',
    tip: '可查看/编辑文档',
  },
  {
    value: joyspacePermissionType.ReadDel,
    label: '删除',
    tip: '删除文档权限',
  },
];

export const folderMenus = [
  {
    value: joyspacePermissionType.ReadOnly,
    label: '仅阅读',
    tip: '可查看文档和文件夹',
  },
  {
    value: joyspacePermissionType.ReadWrite,
    label: '可编辑',
    tip: '可查看/编辑文档和文件夹',
  },
  {
    value: joyspacePermissionType.ReadDel,
    label: '删除',
    tip: '删除文档权限和文件夹权限',
  },
];
